import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./PageFooter.module.css";
import logo from "./WWG_Logo.svg";
import mobile from "mobileBridge";
import { useTranslation } from "react-i18next";

export function PageFooter({ onClick }) {
  const {t} = useTranslation();
  const [appVersion, setAppVersion] = useState(false);

  useEffect(() => {
    if (mobile.isApp()) {
      mobile.getAppVersion().then((currentVersion) => {
        setAppVersion(currentVersion);
      });
    }
  }, []);

  return (
    <div className={styles.container}>
      <img src={logo} alt="Logo" className={styles.logo} />
      <div className={styles.textContainer}>
        <span className={styles.boldText}>&copy; WWG&trade;</span>
        {mobile.isApp() ? (
          <span>{appVersion}</span>
        ) : (
          <span>Copyright 2025</span>
        )}
        <span>All rights reserved</span>
      </div>
      {mobile.isApp() && (
        <button className={styles.logoutButton} onClick={onClick}>
          {t("Logout")}
        </button>
      )}
    </div>
  );
}

PageFooter.propTypes = {
  onClick: PropTypes.func,
};
